<template>
    <div class="col-sm-12 nopads">
        <div class="col-sm-12 nopads pt-2 px-2">
            <TransitionGroup name="fade">
                <div key="search-contract-list">
                    <weekly-contract-report-search
                        @search="fetchDiaries"
                    />

                    <div class="col-sm-12 my-3">
                        <div
                            class="data-list-item add"
                            @click.stop="createSiteReport"
                        >
                            <div class="item-img-cont add-title">
                                <i class="fa fa-plus" />
                            </div>
                            <div class="item-text-cont">
                                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                                <font-awesome-icon
                                    icon="file-contract"
                                    class="card-body-icon"
                                />
                            </div>
                        </div>
                    </div>
                    <contract-weekly-diary-list
                        :results="results"
                        @edit="editSiteReport"
                        @row-click="showPrintableSummary"
                    />
                </div>
            </TransitionGroup>
            <base-modal
                v-if="editMode"
                size="lg"
                hide-header
                hide-footer
                hide-header-close
            >
                <contract-weekly-diary-editor
                    v-model="siteReport"
                    :report-list-view="false"
                    @close="showList"
                    @close-and-update="closeAndUpdate"
                />
            </base-modal>
            <base-modal
                v-if="summaryMode"
                size="lg"
                hide-footer
                @close="summaryMode=false"
            >
                <city-contract-diary
                    mode="weekly"
                    :diary="selectedDiary"
                    :contract="lastSearchedParams.contract"
                    @close="closeSummary"
                />
            </base-modal>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </div>
</template>

<script>

import ContractDiaryList from "@/components/contractreport/ContractDiaryList.vue";
import BaseModal from "@/components/BaseModal.vue";
import ContractWeeklyDiaryEditor from "@/components/contractreport/ContractWeeklyDiaryEditor.vue";
import {restApi} from "@/components/mixins/RestApiMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import ContractWeeklyDiarySearch from "@/components/contractreport/ContractWeeklyDiarySearch.vue";
import ContractWeeklyDiaryList from "@/components/contractreport/ContractWeeklyDiaryList.vue";
import CityContractDiary from "@/components/contractreport/CityContractDiary.vue";
import {workManagementHelper} from "@/components/mixins/WorkManagementMixin";
import {inject} from "vue";

export default {
    name: "ContractWeeklyDiaryReport",
    components: {BaseModal, WeeklyContractReportSearch: ContractWeeklyDiarySearch, ContractDiaryList, ContractWeeklyDiaryEditor, ContractWeeklyDiaryList, CityContractDiary},
    mixins: [restApi, timeUtils, workManagementHelper],
    props: {},
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            results: null,
            loading: false,
            siteReport: null,
            isElyContract: false,
            editMode: false,
            summaryMode: false,
            selectedDiary: null,
            lastSearchedParams: null
        }
    },
    methods: {
        createSiteReport() {
            this.siteReport = this.newSiteReport()
            this.editMode = true
        },
        editSiteReport(diary) {
            this.siteReport = this.jsonToItem(diary)
            this.editMode = true
        },
        showPrintableSummary(diary) {
            this.selectedDiary = this.jsonToItem(diary)
            this.summaryMode = true
        },
        closeSummary() {
            this.selectedDiary = null
            this.summaryMode = false
        },
        newSiteReport: function () {
            return {
                id: -1,
                events: "",
                deviations: "",
                duty_officer: null,
                supervisors: null,
                customer_contacts_info: "",
                customer_contacts_received: false,
                citizen_contacts_received: false,
                citizen_contacts_info: "",
                authorities_assistance: false,
                authorities_assistance_hours: 0,
                authorities_assistance_info: "",
                contract: null,
                exceptional_weather: false,
                exceptional_weather_info: "",
                exceptional_weather_location: "",
                media_contacts_info: "",
                media_contacts_received: false,
                record_date: null,
                record_end_date: null,
                type: "weekly"
            }
        },
        fetchDiaries(params) {
            this.results = []
            if(!params || !params.contract) {
                this.showAlert(this.$t('contract_diary.invalid_contract'))
                return undefined
            }
            this.isElyContract = params.contract.ely_contract
            let mappedParams = {
                contract: params.contract ? params.contract.id : null,
                from: params.startDate ? this.getDateIsoString(new Date(params.startDate)) : null,
                to: params.endDate ? this.getDateIsoString(new Date(params.endDate)) : null,
            }
            this.lastSearchedParams = params
            this.loading = true
            this.restFetchParams(this.contractWeeklyDiaryUrl, mappedParams, this.handleResponse)

        },
        handleResponse: function (response) {
            if (response && response.data) {
                this.results = Array.isArray(response.data) ? response.data : []
            }
            this.loading = false
        },
        showList() {
            this.siteReport = null
            this.editMode = false
        },
        closeAndUpdate() {
            this.siteReport = null
            if(this.lastSearchedParams && this.lastSearchedParams.contract) {
                this.fetchDiaries(this.lastSearchedParams)
            }
            this.showList()
        }
    }
}
</script>
